import type { RoundUnit } from "../simulationRound/SimulationRoundItem";

export const operators = {
  "+": {
    op: "+",
    name: "add"
  },
  "-": {
    op: "-",
    name: "subtract"
  },
  "*": {
    op: "*",
    name: "multiply"
  },
  "/": {
    op: "/",
    name: "divide"
  },
  "<": {
    op: "<",
    name: "smaller"
  },
  ">": {
    op: ">",
    name: "larger"
  },
  ">=": {
    op: ">=",
    name: "largerEq"
  },
  "<=": {
    op: "<=",
    name: "smallerEq"
  },
  "==": {
    op: "==",
    name: "equal"
  },
  "!=": {
    op: "!=",
    name: "unequal"
  },
  "^": {
    op: "^",
    name: "pow"
  }
} as const;

export const functions = {
  abs: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  floor: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  ceil: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  round: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  sign: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  sqrt: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  mod: {
    args: 2,
    defaultArgs: [0, 2],
    connectors: ["mod"] as string[]
  },
  randbetween: {
    args: 2,
    defaultArgs: [0, 0],
    connectors: ["and"] as string[]
  },
  min: {
    args: 2,
    defaultArgs: [0, 0],
    connectors: ["or"] as string[]
  },
  max: {
    args: 2,
    defaultArgs: [0, 0],
    connectors: ["or"] as string[]
  },
  maxValue: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  minValue: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  pow: {
    args: 2,
    defaultArgs: [0, 2],
    connectors: ["pow"] as string[]
  },
  exp: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  },
  ifelse: {
    args: 3,
    defaultArgs: ["(0)", 0, 0],
    connectors: ["then", "else"] as string[]
  },
  delay: {
    args: 2,
    defaultArgs: [0, 1],
    connectors: ["before"] as string[]
  },
  log: {
    args: 1,
    defaultArgs: [0],
    connectors: [] as string[]
  }
} as const;

const allUnits = ["round", "century", "decade", "year", "halfYear", "quarter", "month", "week", "day", "hour", "minute", "second"] as const;

export const variables = {
  "t": {
    code: "t",
    unitsWhereAvailable: new Set<RoundUnit>(allUnits)
  },
  "year": {
    code: "year",
    unitsWhereAvailable: new Set<RoundUnit>(["century", "decade", "year", "halfYear", "quarter", "month", "week", "day", "hour", "minute", "second"])
  },
  "month": {
    code: "month",
    unitsWhereAvailable: new Set<RoundUnit>(["halfYear", "quarter", "month", "week", "day", "hour", "minute", "second"])
  },
  "week": {
    code: "week",
    unitsWhereAvailable: new Set<RoundUnit>(["halfYear", "quarter", "month", "week", "day", "hour", "minute", "second"])
  },
  "day": {
    code: "day",
    unitsWhereAvailable: new Set<RoundUnit>(["week", "day", "hour", "minute", "second"])
  },
  "hour": {
    code: "hour",
    unitsWhereAvailable: new Set<RoundUnit>(["hour", "minute", "second"])
  },
  "minute": {
    code: "minute",
    unitsWhereAvailable: new Set<RoundUnit>(["minute", "second"])
  },
  "second": {
    code: "second",
    unitsWhereAvailable: new Set<RoundUnit>(["second"])
  },
  "targetCount": {
    code: "targetCount",
    unitsWhereAvailable: new Set<RoundUnit>(allUnits)
  },
  "resourceCount": {
    code: "resourceCount",
    unitsWhereAvailable: new Set<RoundUnit>(allUnits)
  },
  "indexCount": {
    code: "indexCount",
    unitsWhereAvailable: new Set<RoundUnit>(allUnits)
  },
  "PI": {
    code: "PI",
    unitsWhereAvailable: new Set<RoundUnit>(allUnits)
  },
  "E": {
    code: "E",
    unitsWhereAvailable: new Set<RoundUnit>(allUnits)
  },
} as const satisfies {
  [key: string]: {
    code: string;
    unitsWhereAvailable: Set<RoundUnit>;
  }
};
